import { render, staticRenderFns } from "./accessibility-btn.vue?vue&type=template&id=c8c8b822&scoped=true&lang=pug"
import script from "./accessibility-btn.vue?vue&type=script&lang=coffee"
export * from "./accessibility-btn.vue?vue&type=script&lang=coffee"
import style0 from "./accessibility-btn.vue?vue&type=style&index=0&id=c8c8b822&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c8b822",
  null
  
)

export default component.exports